<template>
  <v-card>
    <v-card-title class="py-2 title">
      <v-icon class="mr-2">assignment</v-icon>
      <div class="title info--text">Information</div>
    </v-card-title>
    <v-divider />

    <v-data-table :headers="metadataHeaders" disable-initial-sort hide-headers :items="metadataItems" hide-actions class="elevation-1">
      <template v-slot:items="{ item, index }">
        <tr :class="{ alternate: index % 2 == 0 }">
          <td class="text-xs-left font-weight-medium">{{ item.Field }}</td>
          <td class="text-xs-left">{{ getMetadataValue(item) }}</td>
          <td v-if="editForm" class="text-xs-right">
            <v-tooltip v-if="item.onEdit" :open-delay="500" right>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="item.onEdit(item)" icon>
                  <v-icon color="warning">edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Button.Edit") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <EditContinuousCategoryDialog ref="editContinuousCategoryDialog" :station="continuousStation" />
  </v-card>
</template>

<script>
  import EditContinuousCategoryDialog from './EditContinuousCategoryDialog'

  import {
    getMetadataValue,
  } from '@/helpers/metadata'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  export default {
    components: {
      EditContinuousCategoryDialog,
    },
    props: {
      editForm: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SOURCE_TYPES,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters([
        'currentFeatureDataSourceIndexByType',
        'getSourceName',
      ]),
      ...dataSources.mapGetters([
        'dataSourceIndex',
      ]),
      featureDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.continuousAquarius]
      },
      continuousStation() {
        return this.dataSourceIndex[SOURCE_TYPES.continuousAquarius][this.featureDataSource.SourceId]
      },
      metadataHeaders() {
        let headers = [{
          text: 'Field',
          value: 'Field',
        },
        {
          text: 'FieldType',
          value: 'FieldType',
        },
        ]

        if (this.editForm) {
          headers.push({
            text: 'Actions',
            value: 'action',
          })
        }

        return headers
      },
      metadataItems() {
        let staticMetadata = [{
          Field: 'Station Category',
          FieldType: 'String',
          FieldValue: this.continuousStation && this.continuousStation.LocationType,
          Ordinal: 1,
          onEdit: this.editContinuousCategory,
        },
        {
          Field: 'Data Type',
          FieldType: 'String',
          FieldValue: 'Continuous Data',
          Ordinal: 2,
        },
        ]

        return staticMetadata
      },
    },
    methods: {
      getMetadataValue,
      editContinuousCategory() {
        this.$refs.editContinuousCategoryDialog.show()
      },
    },
  }
</script>